import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function CTASection() {
  return <section id="contact" className="bg-sure-black w-full py-32 md:py-48 relative overflow-hidden" data-id="element-37">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-sure-accent/5 rounded-full blur-[120px] pointer-events-none" data-id="element-38" />

      <div className="max-w-[1600px] mx-auto px-6 md:px-12 relative z-10 flex flex-col items-center text-center" data-id="element-39">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-sure-white text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6 max-w-3xl" data-id="element-40">
          Ready to see what your network already knows?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="text-sure-gray text-base md:text-lg font-light leading-relaxed max-w-[600px] mb-12" data-id="element-41">
          Book a 30-minute briefing with our team. No pitch decks — just a live
          walkthrough of what SURE AI can do with your existing infrastructure.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center gap-6" data-id="element-42">
          <Link to="/contact" className="px-8 py-4 bg-sure-white text-sure-black text-sm uppercase tracking-widest font-medium hover:scale-[1.02] hover:bg-gray-100 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sure-accent focus:ring-offset-2 focus:ring-offset-sure-black inline-block text-center w-full sm:w-auto" data-id="element-43">
            Request a Briefing
          </Link>
          <Link to="/contact" className="px-8 py-4 border border-sure-white text-sure-white text-sm uppercase tracking-widest font-medium hover:bg-sure-white hover:text-sure-black transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sure-accent focus:ring-offset-2 focus:ring-offset-sure-black inline-block text-center w-full sm:w-auto" data-id="element-44">
            Arrange a Demonstration
          </Link>
        </motion.div>
      </div>
    </section>;
}